import { Chip } from '@mui/material';
import { IPropsBusinessPage } from '../Business';
import { serviceService } from '../../../shared/services/api/serviceService';
import { BusinessServicesRegister } from './BusinessService';
import { formatDuration } from '../../../shared/helpers/formatDuration';
import { CrudListPage } from '../../../shared/components/SconApp/crud/CrudListPage';

export const BusinessServices: React.FC<IPropsBusinessPage> = ({ business, refetch }) => (
  <CrudListPage
    items={business.services ?? []}
    businessId={business.id!}
    entityName='service'
    removeApi={(id) => serviceService.remove(id)}
    onRefetch={refetch}
    RegisterForm={BusinessServicesRegister}
    dialogTestId='dialog-service-register'
    deleteLabel='Tem certeza que deseja deletar este serviço?'
    mapToItem={(item) => ({
      id: item.id || 0,
      description: `${item.description} - ${formatDuration(item.serviceDuration)} - R$${item.amount}`,
      endAdornment: (
        <>
          <Chip
            label={item.isActive ? 'Ativo' : 'Inativo'}
            size='small'
            color={item.isActive ? 'success' : 'default'}
            variant={item.isActive ? 'filled' : 'outlined'}
          />
          <Chip
            label={item.requiresPreApproval ? 'Requer aprovação' : 'Não requer aprovação'}
            size='small'
            color={item.requiresPreApproval ? 'primary' : 'default'}
            variant={item.requiresPreApproval ? 'filled' : 'outlined'}
          />
        </>
      ),
    })}
  />
);
